import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, FlexBox } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { getUserDisplayName } from 'utils/user/getUserDisplayName';
import styles from './userProfile.module.scss';
/**
 * Represents the component for displaying the user profile which includes an
 * avatar and a display name inferred from the provided user object.
 */
export const UserProfile = ({ avatarSize = '24', className, description, descriptionClassName, nameClassName, truncateDescription, truncateName, unknownLabel = 'Unknown', user, }) => {
    // Disable until TEAMS-7646 & TEAMS-7647 are done.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const avatarUser = user;
    return (_jsxs(FlexBox, Object.assign({ className: classnames(styles.root, className), alignItems: "center", gap: sizes.spacer[250] }, { children: [avatarSize && (_jsx(Avatar, { className: styles.avatar, size: avatarSize, user: avatarUser })), _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsx("div", Object.assign({ className: classnames(styles.name, nameClassName, {
                            [styles.truncate]: truncateName,
                        }) }, { children: user ? getUserDisplayName(user) : unknownLabel })), description && (_jsx("div", Object.assign({ className: classnames(styles.description, descriptionClassName, {
                            [styles.truncate]: truncateDescription,
                        }) }, { children: description })))] }))] })));
};
